/**
 * Escalera de oferta.
 *
 * Cada peldano es un radio que apunta a una variante y una cantidad. Al elegir
 * uno, se escriben los dos campos que el formulario de Horizon ya usa:
 * input[name="id"] y input[name="quantity"]. No se toca nada mas: el boton de
 * agregar, el de comprar ahora y la validacion siguen siendo los de Horizon.
 *
 * La invariante que sostiene todo: lo que se muestra en el peldano elegido es
 * lo que se cobra. Por eso al conectarse tambien sincroniza, y no solo al hacer
 * clic — si el formulario y la seleccion no coinciden, el precio miente.
 */
class OfferLadder extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#onChange);
    this.#sync();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onChange);
  }

  #onChange = (event) => {
    if (event.target instanceof HTMLInputElement && event.target.type === 'radio') this.#sync();
  };

  get #form() {
    const section = this.closest('.shopify-section') ?? document;
    return section.querySelector('form[action*="/cart/add"]');
  }

  #sync() {
    const checked = this.querySelector('input[type="radio"]:checked');
    const form = this.#form;
    if (!checked || !form) return;

    const variantId = checked.dataset.variantId;
    const quantity = checked.dataset.quantity ?? '1';

    const idInput = form.querySelector('input[name="id"]');
    if (idInput && variantId && idInput.value !== variantId) {
      idInput.value = variantId;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const qtyInput = form.querySelector('input[name="quantity"]');
    if (qtyInput && qtyInput.value !== quantity) {
      qtyInput.value = quantity;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

if (!customElements.get('offer-ladder')) customElements.define('offer-ladder', OfferLadder);
